import CirgsReportDetailsSection from './CirgsReportDetailsSection';

export default CirgsReportDetailsSection;
